import Layout1 from "../pages/Layout1/Layout1"

const Routes = [
  { path: "/", component: <Layout1 /> },
];

export default Routes;